<template lang="">
    <div>
        <div class="">
            <div class="floatbtn" @click="showcontact">
                <img :src="base_url+'/files/images/ctbtn.png'">
            </div>
            <modal ref="info" name="聯絡我們" style="z-index: 1060;">
                <template v-slot:default>
                    <div class="from-group">
                        <div class="text-center">客服電話：<br><a href="tel:+886-4-25376688"
                                style="color: blue;">04-2537-6688</a></div><br>
                        <div class="text-center">技術服務電話：<br><a href="tel:+886-4-25390493"
                                style="color: blue;">04-2539-0493</a></div><br>
                        <div class="text-center">服務時間：09:00-17:00</div>
                    </div>
                </template>
            </modal>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                base_url
            }
        },
        methods: {
            showcontact() {
                this.$refs.info.modalShow();
            },
        },
    }
</script>
<style scoped>
    .floatbtn {
        position: fixed;
        bottom: 70px;
        left: -21px;
        cursor: pointer;
        z-index: 1000;
        padding: 5px 20px;
    }
</style>